export default __webpack_public_path__ + "static/media/fastplaybtn.e0cfe0f2.mp3";